require('./myProfileEditView.scss');

// @ vendor
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');

// @utilities
const { changeBiocatchContext } = require('utilities/biocatch');
const { emailSentModalLink } = require('utilities/taggingInfo/profileEditorViewTagging');

// @ actions
const profile = require('actions/profile');
const profileEditorActions = require('actions/profileEditor');
const profileEditorSettingsActions = require('actions/profileEditorSettings');
const printerActions = require('actions/contactCenter/printer');
const fiocDocumentation = require('actions/fiocDocumentation');
const myProfileShippingAddressActions = require('actions/myProfileShippingAddress');
const modifyMainPhoneActions = require('actions/contactCenter/modifyMainPhone/modifyMainPhone');
const interstitialGenericActions = require('actions/interstitialGeneric');
// @ commons
const { formatText, FormattedText } = require('core/i18n').i18n;
const OKHeaderLanding = require('components/commons/OKHeaderLanding/OKHeaderLanding');
const { OKCover } = require('commonsComponents/OKCover');
const { OKMessage } = require('commonsComponents/OKMessage');
const { CommercialAdsCCValidated: CommercialAds } = require('components/commons/commercialAds/commercialAds');

// @ components
const { ContactInfoBoxCCValidated: ContactInfoBox } = require('components/myProfile/contactInfoBox/contactInfoBox');
const PersonalData = require('components/myProfile/personalData/personalData');
const ProfilePictureEditor = require('components/myProfile/profilePictureEditor/profilePictureEditor');
const TutorialLauncher = require('components/tutorial/tutorialLauncher');
const { CallMeBack } = require('components/callMeBack/callMeBack');
const ErrorStep = require('components/myProfile/myProfileEditor/ErrorStep');
const SuccessStep = require('components/myProfile/myProfileEditor/SuccessStep');
const OKModal = require('components/commons/OKModal/OKModal');
const { printGenericDocument } = require('components/contactCenter/printer');
const WebappRender = require('components/conditionalRender/webappRender');
const { LoadingSection } = require('commonsComponents/loadingSection');
const AvailPromotionSuccessStep = require('components/promotions/availPromotions/availPromotionSuccessStep');
// @ helpers
const { conditionalClassName } = require('utilities/conditionals/conditionalClassname');
const UrlHelper = require('utilities/urlHelper');

// @ constants
const {
    PROC_CHANGE_PICTURE,
    PROC_START,
    recordPath,
    recordProcess,
} = require('utilities/tagging');
const {
    ADVANCED_INTERSTITIAL_SUCCESS_PAGE_EVENT,
    GRAPHIC_TUTOR_TYPE_4,
} = require('constants/index');
const biocatch = require('constants/biocatch');
const {
    PROFILE_EDIT_FORMS: {
        ADDRESS,
        EMAIL,
        PHONE
    }
} = require('constants/myProfileEditor');

class MyProfileEditView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            toggleEditPicture: false,
            emailOrPhoneChanged: false,
            showModel: false,
            otp: '',
        };
        this.onProfileEditSubmit = this.onProfileEditSubmit.bind(this);
        this.handleAliasChange = this.handleAliasChange.bind(this);
        this.handlePictureEdit = this.handlePictureEdit.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleFinish = this.handleFinish.bind(this);
        this.isReady = this.isReady.bind(this);
        this.beforeLeaving = this.beforeLeaving.bind(this);
        this.handleConfirmLeave = this.handleConfirmLeave.bind(this);
        this.handleCloseModel = this.handleCloseModel.bind(this);
        this.verifyOtpEmail = this.verifyOtpEmail.bind(this);
        this.setOtp = this.setOtp.bind(this);
    }

    componentDidMount() {
        const {
            fiocDocumentation,
            getFiocStatus,
            getShippingAddress,
            immProfileShippingAddress,
            reset,
            requestProfile,
            requestContactPhoneData,
            resetPhoneData,
            history,
        } = this.props;

        reset();
        requestProfile(history);
        if (__CONTACT_CENTER__) {
            requestContactPhoneData()
            resetPhoneData()
        }

        if (!fiocDocumentation.get('fetched') && !fiocDocumentation.get('isStatusFetching')) {
            getFiocStatus();
        }

        if ((!immProfileShippingAddress.get('fetchSuccess') && !immProfileShippingAddress.get('isFetching')) ||
            immProfileShippingAddress.get('isEditMode')) {
            getShippingAddress();
        }
    }

    componentWillReceiveProps(nextProps) {
        const { immProfileEditor, routingState, reset } = this.props;
        const currentPath = routingState.locationBeforeTransitions.pathname;
        const newPath = nextProps.routingState.locationBeforeTransitions.pathname;
        if (currentPath == newPath && immProfileEditor.get('submitSuccessful')) {
            reset();
        }
    }

    componentWillUnmount() {
        const { reset, resetAdvancedInterstitialFlag } = this.props;
        reset();
        resetAdvancedInterstitialFlag();
    }

    setOtp(value) {
        this.setState({ otp: value });
        this.setState({ toggleEditPicture: false });
    }

    verifyOtpEmail() {
        const { profileVerifyOtpEmail } = this.props;
        const { otp } = this.state;
        profileVerifyOtpEmail({ otp });
    }

    onProfileEditSubmit(value, preview, isAvatar) {
        const { updateProfilePicture } = this.props;
        this.setState({ toggleEditPicture: false });
        updateProfilePicture(value, preview, isAvatar);
    }

    beforeLeaving() {
        const { immProfileEditor, reset, resetPhoneData } = this.props;
        if (immProfileEditor.get('submitSuccessful') && immProfileEditor.get('willLeave')) {
            reset();
            resetPhoneData()
        }
    }

    buildEditor() {
        const {
            actionChangeValue,
            flagBasedFeatures,
            history,
            immAccounts,
            immHireContactData,
            immModifyMainPhone,
            immProfileEditor,
            immProfileFields,
            immProfileShippingAddress,
            profileAvatarEditorModalShow,
            setProfileAvatarEditorError,
            setVisibleStep,
            setWillCancel,
            validateStep,
            setEditingTaxAdditionalCountry,
            fiocDocumentation,
            updateAdditionalCountries,
            deleteAdditionalCountries,
            setField,
            setEmailUuid,
            setEditMode,
            initProfileOtpEmail,
            resendOtpEmail,
        } = this.props;

        const boxTitle = formatText('profile-boxTitle');
        const boxBody = (
            <OKMessage type="important">
                <FormattedText value="profile-boxBody" />
            </OKMessage>
        );
        const titleHeader = formatText('profile-titleHeader');
        const leftColumnClassName = conditionalClassName('col-xs-12 col-md-8', 'profile-edit-view__left-column col-xs-12')
        const rightColumnClassName = conditionalClassName('col-xs-12 col-md-4', 'col-xs-12')

        return (
            <div>
                <div className="profile-edit-view row grid-view--content-position-positive">
                    <div className={leftColumnClassName}>
                        <div className="row">
                            <div className="col-md-12">
                                <ProfilePictureEditor
                                    editable={this.state.toggleEditPicture}
                                    fields={immProfileFields}
                                    handleSubmit={this.onProfileEditSubmit}
                                    onClick={this.handlePictureEdit}
                                    onAliasChange={this.handleAliasChange}
                                    onChangeModal={profileAvatarEditorModalShow}
                                    setProfileAvatarEditorError={setProfileAvatarEditorError}
                                />
                            </div>
                            <div className="col-md-12 grid-view--fix-cell-separation">
                                <PersonalData
                                    actionChangeValue={actionChangeValue}
                                    flagBasedFeatures={flagBasedFeatures}
                                    maskContent={this.maskContent}
                                    history={history}
                                    immAccounts={immAccounts}
                                    immHireContactData={immHireContactData}
                                    immProfileFields={immProfileFields}
                                    immProfileEditor={immProfileEditor}
                                    immProfileShippingAddress={immProfileShippingAddress}
                                    immModifyMainPhone={immModifyMainPhone}
                                    validateStep={validateStep}
                                    setField={setField}
                                    setVisibleStep={setVisibleStep}
                                    setWillCancel={setWillCancel}
                                    updateAdditionalCountries={updateAdditionalCountries}
                                    deleteAdditionalCountries={deleteAdditionalCountries}
                                    onCancel={this.handleCancel}
                                    onFinish={this.handleFinish}
                                    isReady={this.isReady}
                                    beforeLeaving={this.beforeLeaving}
                                    onConfirmLeave={this.handleConfirmLeave}
                                    setEditingTaxAdditionalCountry={setEditingTaxAdditionalCountry}
                                    editMode={immProfileEditor.get('editMode')}
                                    setEditMode={setEditMode}
                                    fiocDocumentation={fiocDocumentation}
                                    onHandleSetOtp={this.setOtp}
                                    onHandleVerifyOtpEmail={this.verifyOtpEmail}
                                    onHandleNextClick={this.openWarningEmailOtpSentModal}
                                    otp={this.state.otp}
                                    setEmailUuid={setEmailUuid}
                                    initProfileOtpEmail={initProfileOtpEmail}
                                    resendOtpEmail={resendOtpEmail}
                                />
                            </div>
                        </div>
                    </div>
                    <div className={rightColumnClassName}>
                        <div className="row">
                            <div className="col-xs-6 col-md-12 grid-view--variable-cell-separation">
                                <WebappRender>
                                    <ContactInfoBox
                                        boxBody={boxBody}
                                        boxTitle={boxTitle}
                                        hasMessage={true}
                                    />
                                </WebappRender>
                            </div>
                            <div className="col-xs-6 col-md-12 grid-view--fix-cell-separation">
                                <CallMeBack pageTitle={titleHeader} hasEntrance={false}/>
                            </div>
                            <WebappRender>
                                <div className="col-xs-12 grid-view--fix-cell-separation">
                                    <CommercialAds path="edit" type="banner-a" />
                                </div>
                            </WebappRender>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    buildEditorBody() {
        const {
            immProfileEditor,
            immProfileFields,
            immModifyMainPhone,
            immInterstitialGenericModal,
            immAdvancedInterstitialPromotions,
            location,
            resetAdvancedInterstitialFlag
        } = this.props;
        const isFetching = immProfileEditor.get('isFetching');
        const editMode = immProfileEditor.get('editMode');
        const { CHANGE_PHONE, CHANGE_ADDRESS, CHANGE_EMAIL } = biocatch;

        const contexts = {
            PHONE: CHANGE_PHONE,
            ADDRESS: CHANGE_ADDRESS,
            EMAIL: CHANGE_EMAIL
        };

        changeBiocatchContext(contexts[editMode]);

        const submitSuccessful = immProfileEditor.get('submitSuccessful');
        const hasError = immProfileEditor.get('errorReceived') !== '' ||
            immProfileFields.get('error') ||
            (__CONTACT_CENTER__ && immModifyMainPhone.get('phoneDataError'));
        let bodyContent;

        if (!__CONTACT_CENTER__) {
            bodyContent = this.buildEditor()
        }
        else if (immModifyMainPhone.get('isFetchingData')) {
            bodyContent = <LoadingSection />
        }
        else if (immModifyMainPhone.get('phoneDataFetched')) {
            bodyContent = this.buildEditor();
        }

        __CONTACT_CENTER__ && printGenericDocument(bodyContent);
        const allowedFields = [PHONE, EMAIL, ADDRESS];
        const queryParams = location.search && UrlHelper.getQueryParams(location.search.substr(1));
        const alreadyUpdated = queryParams && queryParams.updated;

        const advancedInterstitialFlag = immInterstitialGenericModal.get('fromAdvancedInterstitialModal')

        if ((!isFetching && submitSuccessful) || alreadyUpdated) {

            if ((allowedFields.includes(editMode) && advancedInterstitialFlag) || alreadyUpdated) {
                recordPath(ADVANCED_INTERSTITIAL_SUCCESS_PAGE_EVENT);
                bodyContent = (
                    <AvailPromotionSuccessStep
                        alreadyUpdated={alreadyUpdated}
                        immProfileEditor={immProfileEditor}
                        immProfileFields={immProfileFields}
                        isPromotionHired={immAdvancedInterstitialPromotions.getIn(['promotions', 'isHired'])}
                        onConfirmLeave={this.handleConfirmLeave}
                        columns={1}
                        bodyWordBreak={false}
                        resetAdvancedInterstitialFlag={resetAdvancedInterstitialFlag}
                    />
                );
            } else {
                bodyContent = (
                    <SuccessStep
                        immProfileEditor={immProfileEditor}
                        immProfileFields={immProfileFields}
                        onConfirmLeave={this.handleConfirmLeave}
                        columns={1}
                        bodyWordBreak={false}
                    />
                );
            }

        } else if (hasError) {
            bodyContent = (
                <ErrorStep
                    onConfirmLeave={this.handleConfirmLeave}
                />
            );
        }

        return bodyContent;
    }

    buildTutorial() {
        const { immProfileEditor } = this.props;
        const editMode = immProfileEditor.get('editMode');
        const submitSuccessful = immProfileEditor.get('submitSuccessful');
        const hasError = immProfileEditor.get('errorReceived') !== '';
        let dataToRender = null;

        if (!!editMode && !submitSuccessful && !hasError) {
            dataToRender = <TutorialLauncher type={GRAPHIC_TUTOR_TYPE_4} title={formatText('tutorials-profileDataTitle')} />;
        }

        return dataToRender;
    }

    handleAliasChange(alias) {
        const { setUserAlias } = this.props;
        setUserAlias(alias);
    }

    handleCancel() {
        this.props.history.push('/myprofile/edit');
    }

    handleCloseModel() {
        const { removeDocumentListError } = this.props;
        removeDocumentListError();
        this.setState({
            showModel: false
        })
    }

    handleConfirmLeave() {
        const {
            reset,
            requestProfile,
            resetPrintedIndicators,
            resetPhoneData,
            requestContactPhoneData,
            history,
        } = this.props
        reset();
        this.setState({ toggleEditForm: false });

        requestProfile(history);

        if (__CONTACT_CENTER__) {
            resetPrintedIndicators();
            resetPhoneData();
            requestContactPhoneData();
        }
    }

    handleFinish() {
        const {
            postAddressChange,
            postEmailChange,
            postFiscalDataChange,
            postPhoneChange,
            immProfileEditor,
            requestProfile,
        } = this.props;

        const editActions = {
            ADDRESS: postAddressChange,
            EMAIL: postEmailChange,
            PHONE: postPhoneChange,
        };

        if (__CONTACT_CENTER__) {
            editActions.FISCAL_DATA = postFiscalDataChange
        }
        editActions[immProfileEditor.get('editMode')](requestProfile);
    }

    handlePictureEdit() {
        if (!this.state.toggleEditPicture) {
            recordProcess(PROC_CHANGE_PICTURE, PROC_START);
        }
        this.setState({ toggleEditPicture: !this.state.toggleEditPicture });
    }
    isReady() {
        return false;
    }

    // from 34664555256 returns +34 6** **5 256
    maskContent(content) {
        const cleanContent = content.replace(/\-/g, '');

        return `+${cleanContent.substr(0, 2)} ${cleanContent.substr(2, 1)}** **${cleanContent.substr(7, 1)} ${cleanContent.substr(8)}`;
    }
    render() {
        const editorBody = this.buildEditorBody();
        const tutorial = this.buildTutorial();
        const titleHeader = formatText('profile-titleHeader');
        const { isRequestOtp = false } = this.props.immProfileEditor.toJS();

        return (
            <div>
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="small" section="pg" customClass="col-xs-12">
                            <OKHeaderLanding tutorial={tutorial} title={titleHeader} />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        {editorBody}
                    </div>
                </div>
                <OKModal
                    description="fiocSection-documentListErrorModalSubTitle"
                    isOpen={this.state.showModel}
                    onCloseCallback={this.handleCloseModel}
                    footerType="action"
                    primaryButtonText="fiocSection-documentListErrorModalButton"
                    onPrimaryButtonClick={this.handleCloseModel}
                    title="fiocSection-documentListErrorModalTitle"
                />

                <OKModal
                    titleAlignment="center"
                    descriptionAlignment="center"
                    description={formatText('profileEditForm-otp_email_popup_title')}
                    title={formatText('profileEditForm-otp_email_popup_copy')}
                    isOpen={isRequestOtp}
                    onCloseCallback={this.props.closeProfileOtpEmailModal}
                    footerType="action"
                    primaryButtonText="profileEditForm-otp_email_popup_cta"
                    onPrimaryButtonClick={this.props.closeProfileOtpEmailModal}
                    size="large"
                    onAfterOpen={emailSentModalLink}
                />
            </div>
        );
    }
}

MyProfileEditView.propTypes = {
    actionChangeValue: PropTypes.func.isRequired,
    resetPrintedIndicators: PropTypes.func.isRequired,
    cancelAddingAdditionalCountriesState: PropTypes.func,
    closeProfileOtpEmailModal: PropTypes.func.isRequired,
    deleteAdditionalCountries: PropTypes.func,
    getFiocStatus: PropTypes.func.isRequired,
    getShippingAddress: PropTypes.func.isRequired,
    fiocDocumentation: PropTypes.object,
    flagBasedFeatures: PropTypes.object.isRequired,
    immAdvancedInterstitialPromotions: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immHireContactData: PropTypes.object.isRequired,
    immInterstitialGenericModal: PropTypes.bool.isRequired,
    immModifyMainPhone: PropTypes.object.isRequired,
    immProfileEditor: PropTypes.object.isRequired,
    immProfileFields: PropTypes.object,
    immProfileShippingAddress: PropTypes.object.isRequired,
    location: PropTypes.object,
    postAddressChange: PropTypes.func.isRequired,
    postEmailChange: PropTypes.func.isRequired,
    postFiscalDataChange: PropTypes.func.isRequired,
    postPhoneChange: PropTypes.func.isRequired,
    profileAvatarEditorModalShow: PropTypes.func.isRequired,
    requestProfile: PropTypes.func,
    resendOtpEmail: PropTypes.func,
    reset: PropTypes.func.isRequired,
    resetPhoneData: PropTypes.func.isRequired,
    routingState: PropTypes.object,
    requestContactPhoneData: PropTypes.func.isRequired,
    removeDocumentListError: PropTypes.func,
    resetAdvancedInterstitialFlag: PropTypes.func.isRequired,
    setEditingTaxAdditionalCountry: PropTypes.func.isRequired,
    setEditMode: PropTypes.func.isRequired,
    setField: PropTypes.func.isRequired,
    setProfileAvatarEditorError: PropTypes.func.isRequired,
    setUserAlias: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    updateAddingAdditionalCountriesState: PropTypes.func,
    updateAdditionalCountries: PropTypes.func,
    updateProfilePicture: PropTypes.func,
    validateStep: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
};

module.exports.constructor = MyProfileEditView;
module.exports.MyProfileEditView = withRouter(connect(
    state => ({
        fiocDocumentation: state.fiocDocumentation,
        flagBasedFeatures: state.flagBasedFeatures,
        immAccounts: state.accounts,
        immAdvancedInterstitialPromotions: state.advancedInterstitialPromotions,
        immHireContactData: state.hireContactData,
        immInterstitialGenericModal: state.interstitialGeneric,
        immModifyMainPhone: state.modifyMainPhone,
        immProfileEditor: state.profileEditor,
        immProfileFields: state.profile,
        immProfileShippingAddress: state.myProfileShippingAddress,
        routingState: state.routing,
    }), {
    actionChangeValue: profileEditorActions.actionChangeValue,
    closeProfileOtpEmailModal: profileEditorSettingsActions.closeProfileOtpEmailModal,
    deleteAdditionalCountries: profileEditorActions.deleteAdditionalCountries,
    getFiocStatus: fiocDocumentation.getFiocStatus,
    getShippingAddress: myProfileShippingAddressActions.getShippingAddress,
    initProfileOtpEmail: profileEditorSettingsActions.initProfileOtpEmail,
    postAddressChange: profileEditorActions.postAddressChange,
    postEmailChange: profileEditorActions.postEmailChange,
    postFiscalDataChange: profileEditorActions.postFiscalDataChange,
    postPhoneChange: profileEditorActions.postPhoneChange,
    profileAvatarEditorModalShow: profile.profileAvatarEditorModalShow,
    profileVerifyOtpEmail: profileEditorSettingsActions.profileVerifyOtpEmail,
    removeDocumentListError: fiocDocumentation.removeDocumentListError,
    requestContactPhoneData: modifyMainPhoneActions.requestContactPhoneData,
    requestProfile: profile.requestProfile,
    resendOtpEmail: profileEditorSettingsActions.resendOtpEmail,
    reset: profileEditorActions.reset,
    resetAdvancedInterstitialFlag: interstitialGenericActions.resetAdvancedInterstitialFlag,
    resetPhoneData: modifyMainPhoneActions.reset,
    resetPrintedIndicators: printerActions.resetPrintedIndicators,
    setEditingTaxAdditionalCountry: profileEditorActions.setEditingTaxAdditionalCountry,
    setEditMode: profileEditorActions.setEditMode,
    setEmailUuid: profileEditorSettingsActions.setEmailUuid,
    setField: profileEditorActions.setField,
    setProfileAvatarEditorError: profile.setProfileAvatarEditorError,
    setUserAlias: profile.setUserAlias,
    setVisibleStep: profileEditorActions.setVisibleStep,
    setWillCancel: profileEditorActions.setWillCancel,
    updateAdditionalCountries: profileEditorActions.updateAdditionalCountries,
    updateProfilePicture: profile.updateProfilePicture,
    validateStep: profileEditorActions.validateStep,
})(MyProfileEditView));
